<template>
  <div>
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <div class="text-right mb-1 mr-1">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click="assignStudentsProgramme"
              >
                <span class="text-right">
                  <feather-icon icon="CheckIcon" /> Gán chương trình đào tạo
                </span>
              </b-button>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                class="ml-1"
                @click="downloadFile"
              >
                <span class="text-nowrap text-right">
                  <feather-icon icon="DownloadIcon" /> Xuất danh sách sinh viên
                </span>
              </b-button>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="ml-1"
                variant="warning"
                @click="sendMail"
              >
                <span class="text-right">
                  <feather-icon icon="SendIcon" /> Gửi kết quả học tập cho phụ huynh
                </span>
              </b-button>
              <b-button
                v-show="reportExaminationGraduationStudentHbh"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="warning"
                class="ml-1"
                @click="downloadFileExamGraduation"
              >
                <span class="text-nowrap text-right">
                  <feather-icon icon="DownloadIcon" /> Danh sách dự thi tốt nghiệp
                </span>
              </b-button>

              <b-button
                v-if="exportStudentInfo"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="info"
                class="ml-1"
                @click="exportWord('docx')"
              >
                <span class="text-nowrap text-right">
                  <feather-icon icon="DownloadIcon" /> Sổ quản lý sinh viên
                </span>
              </b-button>

              <b-button
                v-if="exportStudentInfo"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="info"
                class="ml-1"
                @click="exportFullReportClass"
              >
                <span class="text-nowrap text-right">
                  <feather-icon icon="DownloadIcon" /> Bảng điểm cả lớp
                </span>
              </b-button>

            </div>
            <b-row>
              <b-col cols="12">
                <vue-good-table
                  mode="remote"
                  class="my-table"
                  :columns="columns"
                  :rows="mainData"
                  :pagination-options="paginationOptions"
                  :total-rows="totalRows"
                  :line-numbers="true"
                  :select-options="selectOptions"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  @on-selected-rows-change="onSelectedRowsChange"
                >
                  <div
                    slot="emptystate"
                    style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>
                  <template
                    slot="table-row"
                    slot-scope="props"
                  >
                    <span v-if="props.column.field === 'status'">
                      {{ getStatusName(props.row.status) }}
                    </span>
                    <span
                      v-else-if="props.column.field === 'action'"
                      class="thead-group-action"
                    >
                      <b-button-group>
                        <b-button
                          v-if="studentClassUpdatable"
                          v-b-modal.classStudentSaveModal
                          variant="primary"
                          class="btn-icon"
                          size="sm"
                          title="Chuyển lớp"
                          @click="onEditMainData(props.row)"
                        >
                          <feather-icon icon="MoveIcon" />
                        </b-button>
                      </b-button-group>
                      <b-button-group>
                        <b-button
                          style="margin-left: 3px;"
                          variant="info"
                          class="btn-icon"
                          size="sm"
                          title="Thông tin"
                          @click="onInfoData(props.row)"
                        >
                          <feather-icon icon="InfoIcon" />
                        </b-button>
                        <b-button
                          style="margin-left: 3px;"
                          variant="success"
                          class="btn-icon"
                          size="sm"
                          title="Bảng điểm toàn khóa"
                          @click="onShowTranscript(props.row)"
                        >
                          <feather-icon icon="FileTextIcon" />
                        </b-button>
                      </b-button-group>
                    </span>
                    <span v-else-if="props.column.field === 'rowNum'">
                      {{ (filter.currentPage-1)* filter.itemsPerPage +props.row.rowNum }}
                    </span>
                    <!-- Column: Common -->
                    <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                  </template>

                  <!-- pagination -->
                  <template
                    slot="pagination-bottom"
                    slot-scope="props"
                  >
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                          đến {{ filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                        </span>
                      </div>
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị </span>
                        <b-form-select
                          v-model="filter.itemsPerPage"
                          :options="itemsPerPageOptions"
                          class="mx-1"
                          @input="(value) => props.perPageChanged({ currentPerPage: value })"
                        />
                        <span class="text-nowrap"> bản ghi/trang</span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="totalRows"
                          :per-page="filter.itemsPerPage"
                          class="mt-1 mb-0"
                          @input="(value) => props.pageChanged({ currentPage: value })"
                        />
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
    <ClassStudentSave
      ref="classStudentSaveFormRef"
      :main-data="currentMainData"
      @succeed="onSucceed"
    />
    <b-modal
      id="modal-info-student"
      ref="modal-info-student"
      ok-only
      ok-title="Chấp nhận"
      centered
      size="xl"
      title="Thông tin sinh viên"
      body-class="position-static"
      hide-footer
    >
      <CurriculumVitae
        :student-id="studentId"
        :class-id="+filter.classId"
        :student-class-id="studentClassId"
        @succeed="onSucceed"
      />
    </b-modal>
    <StudentProgramme
      :course-id="dataSendClass.courseId"
      @save="onSaveStudentsProgramme"
    />
    <b-modal
      id="modal-transcript"
      v-model="transcriptModalVisible"
      title="Bảng điểm toàn khóa"
      size="xl"
      hide-footer
      centered
      :no-close-on-backdrop="false"
      :no-close-on-esc="false"
    >
      <div
        v-if="transcriptLoading"
        class="text-center my-3"
      >
        <b-spinner
          small
          type="grow"
        /> Đang tải dữ liệu...
      </div>
      <div
        v-else-if="transcriptError"
        class="text-danger text-center my-3"
      >
        {{ transcriptError }}
      </div>
      <div v-else-if="transcriptInfo">
        <b-row class="mb-2">
          <b-col cols="4">
            <div><p><b>Họ và tên:</b> {{ transcriptInfo.studentName }}</p></div>
            <div><b>Lớp:</b> {{ transcriptInfo.className }}</div>
          </b-col>
          <b-col cols="4">
            <div><p><b>TBC tích lũy hệ 10:</b> {{ transcriptInfo.cgpaTenth }}</p></div>
            <div><p><b>TBC tích lũy hệ 4:</b> {{ transcriptInfo.cgpaFourth }}</p></div>
          </b-col>
          <b-col cols="4">
            <div><p><b>Số tín chỉ tích lũy:</b> {{ transcriptInfo.accumulatedCreditNum }}</p></div>
            <div><p><b>Xếp hạng học lực:</b> {{ transcriptInfo.academicRank }}</p></div>
          </b-col>
        </b-row>
        <div class="text-right mb-1">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            size="sm"
            class="ml-1 mx-1"
            @click="exportTranscriptExcel"
          >
            <span class="text-nowrap text-right">
              <feather-icon icon="DownloadIcon" /> Bảng điểm toàn khóa
            </span>
          </b-button>
        </div>
        <vue-good-table
          :columns="transcriptColumns"
          :rows="transcriptSubjects"
          :pagination-options="{ enabled: true }"
          :total-rows="transcriptTotalRows"
          :line-numbers="true"
          class="my-table"
        >
          <div
            slot="emptystate"
            style="text-align: center; font-weight: bold"
          >
            Không có dữ liệu môn học!
          </div>
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Hiển thị {{ transcriptFilter.itemsPerPage * (transcriptFilter.currentPage-1) +1 }}
                  đến {{ transcriptFilter.itemsPerPage * (transcriptFilter.currentPage) }} &nbsp; của {{ transcriptTotalRows }} bản ghi
                </span>
              </div>
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Hiển thị </span>
                <b-form-select
                  v-model="transcriptFilter.itemsPerPage"
                  :options="transcriptItemsPerPageOptions"
                  class="mx-1"
                  @input="(value) => props.perPageChanged({ currentPerPage: value })"
                />
                <span class="text-nowrap"> bản ghi/trang</span>
              </div>
              <div>
                <b-pagination
                  :value="transcriptFilter.currentPage"
                  :total-rows="transcriptTotalRows"
                  :per-page="transcriptFilter.itemsPerPage"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                />
              </div>
            </div>
          </template>
        </vue-good-table>
      </div>
      <div
        v-else
        class="text-center"
      >
        Không có dữ liệu bảng điểm
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton, BButtonGroup, BCard, BCol, BContainer, BFormSelect, BOverlay, BPagination, BRow, BSpinner,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { mapActions, mapGetters } from 'vuex'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import ClassStudentSave from '@/views/student-class/ClassStudentSave.vue'
import CurriculumVitae from '@/views/curriculum-vitae/CurriculumVitae.vue'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode, OrganizationCode } from '@/const/code'
import { Workbook } from '@syncfusion/ej2-excel-export'
import StudentProgramme from '@/views/student-class/StudentProgramme.vue'
import { getUser } from '@/auth/utils'
import { showErrorToast, showSuccessToast, showWarningToast } from '@/utils/notification'
import api from './api'

export const Attr = Object.freeze({
  store: 'studentClass',
})
export default {
  name: 'StudentClass',
  directives: {
    Ripple,
  },
  components: {
    StudentProgramme,
    CurriculumVitae,
    ClassStudentSave,
    BButton,
    BButtonGroup,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    VueGoodTable,
    BSpinner,
  },
  props: {
    dataSendClass: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {},
    },
  },
  data() {
    return {
      cUser: getUser(),
      isLoading: false,
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        classId: this.$route.params.id || this.dataSendClass.id,
        sort: '1_asc',
        name: null,
        code: null,
        status: null,
      },
      currentMainData: undefined,
      paginationOptions: {
        enabled: true,
      },
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      studentId: undefined,
      studentClassId: undefined,
      selectOptions: {
        enabled: true,
      },
      selectedRows: [],
      transcriptModalVisible: false,
      transcriptInfo: null,
      transcriptSubjects: [],
      transcriptLoading: false,
      transcriptError: '',
      transcriptColumns: [
        { label: 'Mã môn học, mô đun', field: 'subjectCode' },
        { label: 'Tên môn học, mô đun', field: 'subjectName' },
        { label: 'Số tín chỉ', field: 'totalCreditNum' },
        { label: 'Điểm quá trình (TBKT)', field: 'processScore' },
        { label: 'Điểm thi', field: 'firstScore' },
        { label: 'Điểm TK hệ 10', field: 'averagePoint' },
        { label: 'Điểm TK hệ chữ', field: 'alphabetPoint' },
        { label: 'Điểm TK hệ 4.0', field: 'numbericValue' },
      ],
      transcriptFilter: {
        currentPage: 1,
        itemsPerPage: 10,
      },
      transcriptItemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      transcriptTotalRows: 0,
      classId: null,
    }
  },
  computed: {
    ...mapGetters({
      mainData: `${Attr.store}/dataLists`,
      totalRows: `${Attr.store}/totalRows`,
      statuses: `${Attr.store}/statuses`,
      resourceName: `${Attr.store}/resourceName`,
    }),
    statusFilterDropdownItems() {
      return this.statuses.map(item => ({ value: item.value, text: item.label }))
    },
    reportExaminationGraduationStudentHbh() {
      return this.cUser.orgCode === OrganizationCode.TRUNG_CAP_Y_TE_HOA_BINH && (isSystemAdmin() || hasPermissionForResource(PermissionCode.READ, ResourceCode.HBH_STUDENT_EXAM_GRADUATION))
    },
    columns() {
      return [
        {
          label: 'Mã lớp',
          field: 'classCode',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: `Họ tên ${this.resourceName.shortName}`,
          field: 'name',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: `Mã ${this.resourceName.shortName}`,
          field: 'code',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Chương trình đào tạo',
          field: 'programmeName',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Chuyên ngành',
          field: 'majorName',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Chức danh',
          field: 'titleName',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Trạng thái',
          field: 'status',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
            filterDropdownItems: this.statusFilterDropdownItems,
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Thao tác',
          field: 'action',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ]
    },
    studentClassUpdatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.STUDENT_CLASS)
    },
    exportStudentInfo() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.READ, ResourceCode.TNH_REPORT_STUDENT_MANAGEMENT_REGISTER)
    },
  },
  async created() {
    this.isLoading = true
    try {
      await this.getMainData(this.filter)
      if (this.mainData) {
        this.classId = this.mainData[0].classId
      }
    } catch (e) {
      showErrorToast(this, e)
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    ...mapActions({
      getMainData: `${Attr.store}/getData`,
      getAllData: `${Attr.store}/getAllData`,
      deleteMainData: `${Attr.store}/deleteData`,
      assignProgramme: `${Attr.store}/assignProgramme`,
      sendMailStudyResultForClass: 'studentClass/sendMailStudyResultForClass',
    }),
    onEditMainData(mainData) {
      const {
        rowNum,
        originalIndex,
        vgt_id,
        ...rest
      } = mainData
      this.currentMainData = rest
    },
    onInfoData(mainData) {
      this.studentId = mainData.studentId
      this.studentClassId = mainData.studentClassId || mainData.id
      this.$refs['modal-info-student'].show()
    },
    onDeleteMainData(mainData) {
      this.$swal({
        title: `Bạn chắc chắn muốn xóa ${this.resourceName.fullName} <span class="text-danger">${mainData.name}</span> khỏi lớp độc lập?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.deleteMainData(mainData.id)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                showSuccessToast(this, message)
                try {
                  await this.getMainData(this.filter)
                } catch (e) {
                  showErrorToast(this, e)
                }
              } else {
                showErrorToast(this, message)
              }
            }
          } catch (e) {
            showErrorToast(this, e)
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getMainDataFromStore()
    },
    async getMainDataFromStore() {
      this.isLoading = true
      try {
        await this.getMainData(this.filter)
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async onPerPageChange(param) {
      this.updateParams({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getMainDataFromStore()
    },
    async onSortChange(param) {
      if (param.length > 0) {
        const { field, type } = param[0]
        const selectedColumn = this.columns.findIndex(e => e.field === field)

        this.updateParams({ sort: `${selectedColumn}_${type}` })
      }
      await this.getMainDataFromStore()
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'name')) this.updateParams({ name: columnFilters.name })
      if (Object.hasOwn(columnFilters, 'code')) this.updateParams({ code: columnFilters.code })
      if (Object.hasOwn(columnFilters, 'status')) this.updateParams({ status: columnFilters.status })
      await this.getMainDataFromStore()
    },
    getStatusName(id) {
      const result = this.statuses.find(status => status.value === id)
      if (result) {
        return result.label
      }
      return '---'
    },

    async onSucceed() {
      await this.getMainDataFromStore()
    },
    async downloadFileExamGraduation() {
      const data = await api.downloadExportExamGraduationClass({
        classId: this.filter.classId,
      })
      const a = document.createElement('a')
      document.body.appendChild(a)
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = 'danh-sach-du-thi-tot-nghiep'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    async sendMail() {
      this.isLoading = true
      try {
        const response = await this.sendMailStudyResultForClass(this.classId)
        if (response) {
          const { isSuccessful, message } = response
          if (isSuccessful) {
            showSuccessToast(this, message)
          } else {
            showErrorToast(this, message)
          }
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async downloadFile() {
      const headers = [
        'MA_SINH_VIEN', 'NAME', 'MA_LOP_CO_DINH', 'MA_CTĐT', 'KHOA_HOC',
        'HE_DAO_TAO', 'NGAY_SINH', 'EMAIL', 'CCCD', 'DIA_CHI',
        'SO_BAO_HIEM', 'DAN_TOC', 'TON_GIAO', 'LOAI_KHUYET_TAT', 'TINH',
        'QUAN/HUYEN', 'QUAN/HUYEN', 'NOI_SINH', 'NGAY_VAO_DOAN',
        'NGAY_VAO_DANG', 'NGAY_VAO_DANG_CHINH_THUC',
      ]

      const fieldMap = [
        'code', 'name', 'classCode', 'programmeCode', 'courseName',
        'trainingSystemName', 'birthday', 'email', 'identifyCode', 'address',
        'socialInsurance', 'ethnicName', 'religionName', 'disability', 'provinceName',
        'districtName', '', 'permanentResidence', 'dateYouthGroup',
        'dateDangcongsanGroup', 'dateDangcongsanGroupChinhthuc',
      ]

      const columns = headers.map((_, index) => ({
        index: index + 1,
        width: index === 1 ? 200 : 150,
      }))

      const defaultCellStyle = {
        borders: {
          color: '#00000000',
          lineStyle: 'thin',
        },
      }

      const createCell = (value, index, isHeader = false) => ({
        index,
        value,
        colSpan: 1,
        style: isHeader
          ? {
            ...defaultCellStyle,
            fontColor: '#ffffff',
            backColor: '#000000',
          }
          : { ...defaultCellStyle },
      })

      const headerRow = {
        index: 1,
        cells: headers.map((header, idx) => createCell(header, idx + 1, true)),
      }

      const rows = [headerRow]

      const dataAll = await this.getAllData({
        ...this.filter,
        itemsPerPage: 100000,
      })

      dataAll.forEach((data, rowIdx) => {
        const row = {
          index: rowIdx + 2,
          cells: fieldMap.map((field, colIdx) => {
            const value = field ? data[field] ?? '' : '' // field rỗng → để trống
            return createCell(value, colIdx + 1)
          }),
        }
        rows.push(row)
      })

      const worksheets = [{ columns, rows }]
      const workbook = new Workbook({ worksheets }, 'xlsx')
      workbook.save('ds_sinh_vien_lop_co_dinh.xlsx')
    },

    async exportFullReportClass() {
      try {
        const data = await api.downloadExportTranscriptsZipForClass({ classId: this.classId })
        if (!data) {
          showErrorToast(this, 'Không thể xuất bảng điểm cả lớp')
          return
        }
        const blob = new Blob([data], { type: 'application/zip' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'bang_diem_ca_lop.zip'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)
      } catch (e) {
        showErrorToast(this, 'Không thể xuất bảng điểm cả lớp')
      }
    },

    async exportWord(type) {
      const params = {
        type,
        classId: this.classId,
      }
      this.isLoading = true

      try {
        const data = await api.downloadZip(params)
        if (data) {
          const blob = new Blob([data], { type: 'application/zip' })
          const url = window.URL.createObjectURL(blob)

          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'exported-file.zip') // Tên file tải về
          document.body.appendChild(link)
          link.click()

          // Cleanup
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        } else {
          showErrorToast(this, 'File không có dữ liệu')
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },

    assignStudentsProgramme() {
      if (this.selectedRows.length === 0) {
        showWarningToast(this, 'Vui lòng chọn sinh viên')
        return
      }
      this.$bvModal.show('studentProgrammeSaveModal')
    },
    onSelectedRowsChange(params) {
      this.selectedRows = params.selectedRows
        .map(item => ({ id: item.id }))
    },
    async onSaveStudentsProgramme(programmeId) {
      this.isLoading = true
      try {
        const response = await this.assignProgramme({
          studentClasses: this.selectedRows,
          programmeId,
        })
        if (response) {
          const { isSuccessful, message } = response
          if (isSuccessful) {
            showSuccessToast(this, message)
            this.$bvModal.hide('studentProgrammeSaveModal')
            await this.getMainData(this.filter)
          } else {
            showErrorToast(this, message)
          }
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async onShowTranscript(mainData) {
      this.transcriptModalVisible = true
      this.transcriptInfo = null
      this.transcriptSubjects = []
      this.transcriptLoading = true
      this.transcriptError = ''
      try {
        const { info, subjects } = await api.getInfoStudentCgpa({ studentClassId: mainData?.id })
        this.transcriptInfo = info
        this.transcriptInfo.studentClassId = mainData?.id
        this.transcriptSubjects = subjects
      } catch (e) {
        this.transcriptError = 'Không thể tải dữ liệu bảng điểm!'
      } finally {
        this.transcriptLoading = false
      }
    },

    async exportTranscriptExcel() {
      try {
        const data = await api.downloadExportTranscript({ studentClassId: this.transcriptInfo.studentClassId })
        const a = document.createElement('a')
        document.body.appendChild(a)
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        a.href = url
        a.download = 'Bang_diem_toan_khoa'
        a.click()
        window.URL.revokeObjectURL(url)
      } catch (e) {
        showErrorToast(this, 'Không thể xuất bảng điểm toàn khóa!')
      }
    },
  },
  watch: {
    transcriptSubjects(newVal) {
      this.transcriptTotalRows = Array.isArray(newVal) ? newVal.length : 0
    },
  },
}
</script>

<style lang="scss">
#modal-info-student {
  .modal-dialog,
  .modal-content {
    /* 80% of window height */
    height: 72%;
  }

  .modal-body {
    /* 100% = dialog height, 120px = header + footer */
    max-height: calc(100% - 120px);
    overflow-y: scroll;
  }
}
</style>
